import axios from "axios";
import moment from "moment";

const atestadoStore = {
  namespaced: true,
  state: {
    minHeight: screen.availHeight - 300,
    dados: "",
    atestados: [],
    anexos: [],
    step: 0,
    atestadoEnviar: {
      tipo: 0,
      motivo: 0,
      dependente: 0,
      datainicial: moment().format("YYYY-MM-DD"),
      datafinal: moment().format("YYYY-MM-DD"),
      diasatestado: 1,
      cid: "",
      codMedico: 0,
      nomeMedico: "",
      crmcro: "",
      ddd: "",
      telefone: "",
      justificativa: "",
    },
    configs: [],
    cids: [],
    screen: 0,
    screens: [],
    status: [],
    atestSelec: null,
  },
  mutations: {
    setAtestados(state, atest) {
      state.atestados = atest;
    },
    setStep(state, step) {
      state.step = step;
    },
    setNextStep(state) {
      state.screen++;
      state.step = state.screens[state.screen];
    },
    setBackStep(state) {
      state.screen--;
      state.step = state.screens[state.screen];
    },
    setConfigs(state, config) {
      state.configs = config;
    },
    setCIDS(state, cids) {
      state.cids = cids;
    },
    setScreens(state, tipoSelec) {
      state.screens = [10];
      if (state.dados == "ATESTADOS") {
        state.screens.push(20);
      }
      if (tipoSelec) {
        if (tipoSelec.infdependente) state.screens.push(30);
        if (tipoSelec.infdatas) state.screens.push(40);
        if (tipoSelec.infcid) state.screens.push(50);
        if (tipoSelec.infmedico) state.screens.push(60);
        state.screens.push(70);
      }
      state.screens.push(80);
    },
    setStatus(state, status) {
      state.status = status;
    },
    setAtestSelec(state, atest) {
      state.atestSelec = atest;
    },
    setScreen(state, value) {
      state.screen = value;
    },
    setDados(state, value) {
      state.dados = value;
    },
    setNrDias(state, value) {
      state.atestadoEnviar.diasatestado = value;
    },
    setAnexos(state, anexos) {
      state.anexos = anexos;
    },
  },
  actions: {
    async getAtestados(context) {
      //await axios.get('/colaborador/atestados?funcao=ATESTADOS&dados=ATESTADOS').then((res) => {
      await axios
        .get(
          `/colaborador/atestados?funcao=ATESTADOS&dados=${context.state.dados}`
        )
        .then((res) => {
          if (res.data.success) {
            context.commit("setAtestados", res.data.data);
          } else {
            context.commit("setAtestados", []);
          }
        })
        .catch(() => context.commit("setAtestados", []));
    },
    async getConfigs(context) {
      await axios
        .get(
          `/colaborador/atest-config?funcao=consultar&dados=${context.state.dados}`
        )
        .then((res) => {
          if (res.data.success) {
            context.commit("setConfigs", res.data.data);
          } else {
            context.commit("setConfigs", []);
          }
        })
        .catch(() => context.commit("setConfigs", []));
    },
    async getCIDS(context) {
      await axios
        .get("/colaborador/atestados?funcao=CID-GERAL")
        .then((res) => {
          if (res.data.success) {
            context.commit("setCIDS", res.data.data);
          } else {
            context.commit("setCIDS", []);
          }
        })
        .catch(() => context.commit("setCIDS", []));
    },
    async getStatus(context) {
      context.commit("setStatus", []);
      await axios.get("/colaborador/atestados?funcao=STATUS").then((res) => {
        if (res.data.success) {
          context.commit("setStatus", res.data.data);
        }
      });
    },

    async fetchAnexos({ commit }, codAtestado) {
      try {
        const resp = await axios.get(
          `/colaborador/atestados?funcao=LISTAR-ANEXOS&codAtestado=${codAtestado}`
        );

        if (resp.data && resp.data.success) {
          const anexos = resp.data.anexos || [];
          commit("setAnexos", anexos);
        } else {
          commit("setAnexos", []);
        }
      } catch (err) {
        console.error("❌ fetchAnexos erro:", err);
        commit("setAnexos", []);
      }
    },
  },
  getters: {
    getTipoSelecionado(state) {
      return state.configs.find(
        (config) => config.codigo == state.atestadoEnviar.tipo
      );
    },
    getMotivoSelecionado(state) {
      return state.configs
        .find((config) => config.codigo == state.atestadoEnviar.tipo)
        .situacoes.find((sit) => sit.codigo == state.atestadoEnviar.motivo);
    },
    getCidCompleta(state) {
      try {
        var findCid = state.cids.find(
          (cid) => cid.codigo == state.atestadoEnviar.cid
        );
        return `${findCid.codigo} - ${findCid.descricao}`;
      } catch (error) {
        return "";
      }
    },
    getTiposDocsAnexar(state) {
      if (state.atestadoEnviar.tipo > 0) {
        return state.configs
          .find((config) => config.codigo == state.atestadoEnviar.tipo)
          .anexos.filter(
            (anexo) =>
              anexo.qtdeminimadias <= state.atestadoEnviar.diasatestado &&
              (anexo.codsituacao == state.atestadoEnviar.motivo ||
                anexo.codsituacao == 0)
          );
      } else {
        return [];
      }
    },
    anexosDoAtestado: (state) => state.anexos,
  },
};

export default atestadoStore;
